import React, { useState } from 'react';
import '../styles/Slider.css'; 
import slider1 from '../images/slider1.jpg';
import slider2 from '../images/slider2.jpg';
import slider3 from '../images/slider3.jpg';
import slider4 from '../images/slider4.jpg';
import richMenu1 from '../images/richmenu1.jpg';
import richMenu2 from '../images/richmenu2.jpg';
import richMenu3 from '../images/richmenu3.jpg';
import richMenu4 from '../images/richmenu4.jpg';

const caseStudies = [
  {
    title: "整骨院 / 馬場整骨院",
    description: "ポイントカードを活用することで、来院のたびにポイントを貯めることができ、特典を受けられる仕組みにより、リピート来院率が大幅に向上しています。また、スマートフォンで簡単に提示できるデジタル会員証により、通院の管理も便利になり、患者様との関係強化にも繋がっています。",
    image: slider1,
    richMenuDescription: "リッチメニューは、店舗に合わせてタブで簡単に切り替えができ、利用者が必要な情報にすぐアクセスできる設計です。",
    richMenuImage: richMenu1
  },
  {
    title: "飲食店 / 居酒屋 宴",
    description: "予約システムの導入により、電話対応の負担が大幅に軽減されました。これにより、繁忙時間でもスタッフが業務に集中でき、効率的な店舗運営が実現しています。事前予約が増加し、来店者の流れもスムーズになったことで、売り上げがアップしました。",
    image: slider2,
    richMenuDescription: "リッチメニューにクーポンを表示することで、来店意欲を高め、効果的な集客につながります。",
    richMenuImage: richMenu2
  },
  {
    title: "飲食店 / カフェ KUU",
    description: "店内の混雑状況をリアルタイムで配信し、お客様が混雑を避けて来店できるよう工夫しています。この取り組みにより、来店前に状況を確認して来店することで、待ち時間が少ない快適な体験を提供できるようになりました。これが顧客満足度の向上につながり、リピーターの増加にも貢献しています。",
    image: slider3,
    richMenuDescription: "お客様が事前に提供メニューやおすすめメニューを確認できます。これにより、来店前にメニューをチェックしやすくなり、利用者にとっての利便性が向上します。",
    richMenuImage: richMenu3
  },
  {
    title: "美容室 / ぎゃらりぃ美容室",
    description: "セグメント配信機能を活用することで、顧客の好みやニーズに合った情報を個別に提供しています。このようなパーソナライズされた情報提供により、顧客が自分に合ったタイミングでサロンに足を運ぶきっかけを増やし、実際の来客数がアップしました。",
    image: slider4,
    richMenuDescription: "お知らせ機能が搭載されており、キャンペーンや季節ごとのおすすめメニュー、営業スケジュールの変更など、最新情報をお客様にタイムリーにお届けできます。",
    richMenuImage: richMenu4
  }
];

const Slider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrevClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? caseStudies.length - 1 : prevIndex - 1));
  };

  const handleNextClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % caseStudies.length);
  };

  const currentCaseStudy = caseStudies[currentIndex];

  return (
    <div className="slider-container" id="slider-section">
      <h2 className="slider-title">導入事例</h2>
      
      <button className="slider-button left" onClick={handlePrevClick}>←</button>

      <div className="slider-content">
        <div className="slider-card">
          <h3 className="case-study-title">{currentCaseStudy.title}</h3>
          <div className="case-study-content">
            <img src={currentCaseStudy.image} alt={currentCaseStudy.title} className="case-study-image" />
            <div className="case-study-text">
              <p>{currentCaseStudy.description}</p>
            </div>
          </div>
          <div className="rich-menu-container">
              <p className="rich-menu-description">{currentCaseStudy.richMenuDescription}</p>
              <img src={currentCaseStudy.richMenuImage} alt="リッチメニュー" className="rich-menu-image" />
          </div>
        </div>
      </div>

      <button className="slider-button right" onClick={handleNextClick}>→</button>
    </div>
  );
};

export default Slider;
